<!-- 应收报表 -->
<template>
    <div class="container containerBox">
        <!-- 头部筛选区 -->
        <div class="handleForm">
            <el-form :inline="true" label-width="100px" :model="handleForm" class="demo-form-inline">
                <el-form-item label="选择时间段">
                    <el-date-picker
                        v-model="handleForm.date"
                        type="daterange"
                        @change="handleDateChange"
                        range-separator="至"
                        value-format="yyyy-MM-dd"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <div class="fr">
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>

        <lb-table v-loading="loading"
            :column="tableData.column"
            :data="tableData.data"
            :height="maxHeight"
            border
            pagination
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 20, 50, 100]"
            :current-page.sync="page_num"
            :total="total"
            :page-size="page_sum"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
        </lb-table>

    </div>
</template>

<script>
import Service from '@/api/Service'
import LbTable from '@/components/lb-table/lb-table'

import { getMaxHeigth, FormatDate,FormatNextDate} from '@/utils/utils'

const nowDay = FormatDate("yyyy-MM-dd");
const nextDay = FormatNextDate("yyyy-MM-dd");
export default {
    name: 'balancechange',
    data () {
        return {
            // 搜索参数
            handleForm: {
                from: nowDay,
                to: nextDay,
                oid: '0',
                household_id: '',
                date: [],
				is_house:false,
            },
            // 选择房间组件
            buildRoom: {},
			//显示的数据
            tableData: {
                column: [
                    {
                        prop: 'balance',
                        label: "上次剩余余额",
                    },
                    {
                        prop: 'change_count',
                        label: '操作额度',
                    },
                    {
                        prop: 'description',
                        label: '操作描述',
                    },
                    {
                        prop: 'fin_balance',
                        label: '剩余余额',
                    },
                    {
                        prop: 'pay_type',
                        label: '支付方式',
						formatter: (row, column, cellValue) => {
						    switch(row.pay_type){
						    	case 1:
						    		return "支付宝"
								case 2:
									return "微信"
								case 3:
									return "银联"
								case 4:
									return "现金"
						    	default:
						    		break
						    }
						}
                    },
                    {
                        prop: 'created_time',
                        label: '更新时间',
                    }
                ],
                data: []
            },
            loading: false,
            maxHeight: 500,
            total: 0,
            page_num: 1,
            page_sum: 10,

            spanCom: {},
			schemeId:0,
        };
    },
    components: { LbTable},
    mounted() {
        this.$nextTick(()=>{
            this.maxHeight = getMaxHeigth();
        })
    },
   created() {
        this.schemeId = this.$route.params.oid;
		this.getData()
    },
    methods: {
        // 获取数据
        async getData() {
            let params = {}
            params.household_id = this.schemeId
            params.from = this.handleForm.from;
            params.to = this.handleForm.to;
            params.page_num = this.page_num;
            params.page_sum = this.page_sum;
			
			let res = await Service.getBalanceChange(params)
			if(res){
				this.tableData.data =res.list || []
				this.total = res.total
			}
        },
        // 查询
        onSubmit() {
			this.getData();
        },
        handleDateChange(val) {
            if(val) {
                this.handleForm.from = val[0]
                this.handleForm.to = val[1]
            }else{
                this.handleForm.from = nowDay
                this.handleForm.to = nowDay
            }
        },
        //   获取数据
        handleSizeChange (val) {
            this.page_num = 1
            this.page_sum = val
            this.getData()
        },
        handleCurrentChange (val) {
            if(isNaN(val)) return
            if(val === null) return
            this.page_num = val
            this.getData()
        },
    }
}

</script>
<style lang='css' scoped>
</style>